import React from "react"
import { useOutlet } from "react-router-dom"

export const Campaigns = () => {
  const outlet = useOutlet()

  return <>{outlet}</>
}
